import { c as _c } from "react/compiler-runtime";
import type { NodeValidation, ValidationSeverity } from '@onefootprint/request-types/dashboard';
import { InlineAlert, type InlineAlertVariant } from '@onefootprint/ui';
import { instructionTarget, visibleValidations } from '../store/instruction-validation';
import { useBuilder } from '../store/provider';
type ValidationDetail = NodeValidation['details'][number];
type ValidationAlertsProps = {
  // `null` selects the graph-level findings, which the wire carries with no node id.
  nodeId: string | null;
  /** Findings the page already shows in place, so they don't also stack up as banners. */
  hide?: (detail: ValidationDetail) => boolean;
};
const SEVERITY_TO_VARIANT: Record<ValidationSeverity, InlineAlertVariant> = {
  immediate_error: 'error',
  error: 'error',
  warning: 'warning',
  info: 'info'
};
const ValidationAlerts = t0 => {
  const $ = _c(13);
  const {
    nodeId,
    hide
  } = t0;
  const {
    state
  } = useBuilder();
  let t1;
  let t2;
  let t3;
  if ($[0] !== hide || $[1] !== nodeId || $[2] !== state) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      let t4;
      if ($[6] !== nodeId) {
        t4 = v => v.id === (nodeId ?? undefined);
        $[6] = nodeId;
        $[7] = t4;
      } else {
        t4 = $[7];
      }
      const validation = visibleValidations(state).find(t4);
      let t5;
      if ($[8] !== state.instructionBlocks) {
        t5 = new Set(Object.values(state.instructionBlocks).map(instructionTarget));
        $[8] = state.instructionBlocks;
        $[9] = t5;
      } else {
        t5 = $[9];
      }
      const mountedTargets = t5;
      const details = validation?.details.filter(detail => !hide?.(detail) && !(detail.blockTarget && mountedTargets.has(detail.blockTarget))) ?? [];
      if (details.length === 0) {
        t3 = null;
        break bb0;
      }
      t1 = "flex flex-col gap-2";
      t2 = details.map(_temp);
    }
    $[0] = hide;
    $[1] = nodeId;
    $[2] = state;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  let t4;
  if ($[10] !== t1 || $[11] !== t2) {
    t4 = <div className={t1}>{t2}</div>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
export default ValidationAlerts;
function _temp(detail_0, index) {
  return <InlineAlert key={`${detail_0.code ?? index}-${detail_0.message}`} variant={SEVERITY_TO_VARIANT[detail_0.severity]}>{detail_0.message}</InlineAlert>;
}